import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Transaction, TransactionRequest, TransactionResponse } from './types'
import { $params } from '../../../../features/router'
import moment from 'moment'
export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'transactionId') {
        return ['id', item[1]?.toLowerCase()]
      } else if (item[0] === 'updatedAt' || item[0] === 'createdAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const transactionsListMounted = createEvent<TransactionRequest>()

export const getTransactions = fx<TransactionRequest, TransactionResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const $transactions = restore<Transaction[]>(
  getTransactions.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTransactions = restore(
  getTransactions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: transactionsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'initialAmountUsd' ||
            key === 'initialAmount' ||
            key === 'clientAmount'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getTransactions,
})
